<div class="block-wrapper"
  [class.is-selected]="isSelected"
  [class.cursor-p]="isSelectable"
  [class.not-for-table]="!forTable">
  <div *ngIf="initials" 
    [class.p-2]="!forTable"
    [class.padding-for-table]="forTable">
    <yc-user-initials-block *ngIf="!isMasked ||
      (showMaskedApplicant && canViewMaskedApplicantInfo)"
      [initials]="initials"
      [backgroundColor]="isManager ?
        clientBranding.brandPrimary || '#0974a1' :
        '#0974a1'">
    </yc-user-initials-block>
  </div>
  <div class="d-flex flex-column flex-grow-1 break-word"
    [class.p-2]="!forTable"
    [class.padding-for-table]="forTable"
    [class.d-flex]="isMasked && 
      (!showMaskedApplicant || !canViewMaskedApplicantInfo)">

    <!-- Not Masked -->
    <div class="d-flex align-items-center">
      <div *ngIf="!isMasked ||
        (showMaskedApplicant && canViewMaskedApplicantInfo)"  
        class="name"
        [attr.aria-label]="'common:textApplicantName' | ycI18n: 'Applicant name'">
        <a *ngIf="routerLinkForName" 
          class="anchor-tag"
          [attr.aria-label]="name"
          [routerLink]="routerLinkForName">
          {{ name }}
        </a>
        <span *ngIf="!routerLinkForName" [attr.aria-label]="name">
          {{ name }}
        </span>
      </div>

      <!-- Masked -->
      <div *ngIf="isMasked && 
        (!showMaskedApplicant || !canViewMaskedApplicantInfo)"
        class="masked-applicant">
        <span class="masked-applicant">
          <yc-i18n
            [key]="isNomination ?
              'GLOBAL:textNominatorNameIsMasked' :
              'GLOBAL:textApplicantNameIsMasked'"
            [defaultValue]="isNomination ?
              'Nominator name is masked' :
              'Applicant name is masked'">
          </yc-i18n>
        </span>
      </div>

      <!-- Mask Toggle Button -->
      <div *ngIf="isMasked && showMaskedToggle ?
        topLevelCustomIcon : 
        false"
        class="ms-2">
        <yc-button
          [icon]="true"
          [value]="'common:textShowOrHideMaskedInfo' | ycI18n: 'Show or hide masked info'"
          [tooltipText]="topLevelCustomTooltip"
          (onClick)="toggleShowMaskedApplicants()">
          <yc-fa 
            [icon]="topLevelCustomIcon">
          </yc-fa>
        </yc-button>
      </div>
    </div>

    <!-- Address -->
    <span *ngIf="!isMasked ||
      (showMaskedApplicant && canViewMaskedApplicantInfo)"
      [innerHtml]="addressString"
      [attr.role]="'contentinfo'"
      [attr.aria-label]="'common:textApplicantAddress' | ycI18n: 'Applicant address'">
    </span>
  
    <!-- Email / Phone -->
    <span *ngIf="!isMasked ||
        (showMaskedApplicant && canViewMaskedApplicantInfo)" 
      class="smaller"
      [attr.role]="'contentinfo'"
      [attr.aria-label]="'common:textApplicantEmailAndPhoneNumberAria' | ycI18n: 'Applicant phone number is __phoneNumber__ and email is __email__' : { email: email, phoneNumber: phone}">
      {{ email }} {{ phone ? (' | ' + phone) : '' }}
    </span>

    <!-- Summary numbers -->
    <div *ngIf="summaryNumbers"
      class="text-right">
      <a class="anchor-tag"
        href="javascript:void(0)"
        [attr.role]="'navigation'"
        [attr.aria-label]="'GLOBAL:textViewSummaryNumbers' | ycI18n: 'View summary numbers'"
        placement="left"
        [popover]="applicantStats"
        [outsideClick]="true">
        <yc-fa
          [light]="true"
          icon="chart-bar"
          class="me-2">
        </yc-fa>
        <yc-i18n
          key="GLOBAL:textViewSummaryNumbers"
          defaultValue="View summary numbers">
        </yc-i18n>
      </a>
    </div>
  
  </div>

  <!-- Clear -->
  <button *ngIf="showClear"
    type="button"
    class="clear-applicant"
    [attr.aria-label]="'common:textClose' | ycI18n"
    (click)="onClear.emit()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<ng-template #applicantStats>
  <gc-applicant-org-stats-popover
    [summaryNumbers]="summaryNumbers"
    [hasNominations]="hasNominations"
    [currency]="defaultCurrency">
  </gc-applicant-org-stats-popover>
</ng-template>
